import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import { mapGetters } from "vuex";
import { GET_SEGMENTS_TRANSLATION_MAP } from "@Broker/@Modules/marketing/store/marketing/marketing-getters";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentNameInput",
  components: {
    Select2
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("MarketingStore", [GET_SEGMENTS_TRANSLATION_MAP])), {}, {
    options() {
      return {
        minimumResultsForSearch: Infinity
      };
    },
    nameSelectId() {
      return `name-select-${this.index}`;
    }
  }),
  methods: {
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, cond => {
        var _this$GET_SEGMENTS_TR;
        return {
          id: cond.id,
          text: (_this$GET_SEGMENTS_TR = this.GET_SEGMENTS_TRANSLATION_MAP(cond.name)) != null ? _this$GET_SEGMENTS_TR : cond.name,
          value: cond.name
        };
      });
    },
    handleChange(data) {
      this.$emit("change", data);
    }
  }
});